import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { sweetAlert, sweetAlertWithInput, sweetAlertWithMultiSelector, sweetAlertWithSelector } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DispatchCenterService } from '../../dashboard/dashboard-service/dispatch-center-service';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { MenuService, UserRoles } from '../../shared/layout/menu-service/menu.service';
import { takeUntil } from 'rxjs/operators';
import { Cms1500Service } from 'src/app/service/cms-service/cms1500.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../reports/reports-service/report.service';
import { FilterByKeyPipe } from 'src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { environment } from 'src/environments/environment';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { exit } from 'process';
import { checkRole, isNotCurrentDateTrip } from 'src/app/utils/utils.common';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { TripPurposesService } from '../../trip-purposes/service/trip-purposes.service';
import { SweetAlertService } from '../../shared/sweet-select/sweet-alert.service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';

@Component({
  selector: "app-unassigned",
  templateUrl: "./unassigned.component.html",
  styleUrls: ["./unassigned.component.css"],
})
export class UnassignedComponent implements OnInit, OnDestroy {
  @ViewChild("timer", { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  dataList = [];
  subMenus = [];
  filterdataList = [];
  todayDate;
  status = "";
  isShowAllTrips = false;
  showSlideFilter = false;
  isTimerEnabled = false;
  search: any;
  assignModalObj;
  componentType;
  tripIndex = -1;
  sweepTripsList = null;
  timeZone;
  settingInterval;
  secondaryCompType = null;
  specialRate;
  user;
  cancelTripModalObj;
  selectedTrip;
  billerNoteModalObj;
  additionalNoteModalObj;
  tripLogObj;
  checkListObj;
  aiAssistantConversationObj;
  selectedTrips = [];
  orderBy = "scheduleTime";
  toggleActionButtons: boolean = false;
  view = "grid";
  selectedDropdownIndex: any;
  tripDetailModalObj;
  completedTripModalObj;
  skip = 0;
  editTripModalObj;
  selectedTripId;
  isAllTripsSelected: boolean = false;

  isShowCms1500 = false;
  associateImageModalObj;
  partialEditModalObj;

  tripPurposesAndAddons;
  selectedTripPurpose = '';
  selectedLOS = [];
  selectedSpaceType = [];
  appointmentTypes;
  selectedAptType = [];
  selectedServiceArea = [];
  patients;
  selectedPatient = [];
  drivers;
  selectedDriver = [];
  cooperates;
  selectedCooperate = [];

  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];
  selectedVehicle = '';
  stationManagerList = [];
  selectedStationManager = [];
  preStaffList = {};
  isAllowRates = false;
  isConfirmationCalls = true;
  isNoShow = false;
  isProduction = environment.production;
  tripPurposesList = [];
  assists: any = [];
  preAssistList = {};

  isfarmoutModal: any;
  farmoutDetails;
  isFarmoutIntegration = false;
  templateSaveModalObj;
  cloneTripObj:any;
  routeTrackerObj;
  isStandingOrderChecked: boolean = false;
  isNewRequestChecked: boolean = false;
  isFarmoutChecked: boolean = false;
  isPlannerChecked: boolean = false;
  isStandingOrderClone: boolean = false;
  willCallObj;
  isManual = false;
  outBoundNumber;
  isMarketPlace = false;
  preFleetList = {};
  isSmsAllowed = false;
  allowInprogressTripReassign = false;
  lyftDetailsModalObj;
  isAutoFarmoutDispatch = false;
  columnsSortOrder: any = {
    milage: '',
    preSpecialRate: '',
    scheduleTime: '',
    appointmentTime: ''
  }

  constructor(
    private assistService: AssistService,
    private reportService: ReportService,
    private cms1500Service: Cms1500Service,
    private assignTripService: AssigTripsService,
    private dispatchCenterService: DispatchCenterService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private menuService: MenuService,
    private csvService: CsvService,
    private toastr: ToastrService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService,
    private farmoutService: FarmoutService,
    private fleetService: FleetService,
    private tripPurposesService: TripPurposesService,
    private sweetAlertService: SweetAlertService

  ) { }

  ngOnInit() {
    this.getTripPurpose()
    this.getCorporate();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.getFleetList();
    this.getUser();
    this.listenSocket();
    this.getStaffList();
    this.getAssisData();

  }



  setTripStatus(status, isSkipCheck?) {
    if (!isSkipCheck && this.status === status) return;
    this.skip = 0;
    this.clearTrips();
    this.selectedDropdownIndex = -1;
    this.status = status;
    this.getTrips();
    this.reset();
  }

  reset() {
    this.selectedTrips = [];
    this.orderBy = "scheduleTime";
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStaffList() {
    this.staffService
      .getStaffList()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }
  getUser() {
    this.sharedDataService
      .getUser()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          if (data.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = data.isFarmout
          }
          this.timeZone = data.timeZone;
          this.isConfirmationCalls = data.company? data.company.allowConfirmationCalls : data.allowConfirmationCalls;
          this.user = data;

          // this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getStaffRoles();
          if (this.user.hasOwnProperty("isListView") && this.user.isListView) {
            this.view = "list";
          }

          if (this.user.hasOwnProperty("isSms") && this.user.isSms) {
            this.isSmsAllowed = this.user.isSms;
          }

          if (this.user.hasOwnProperty("allowInprogressTripReassign") && this.user.allowInprogressTripReassign) {
            this.allowInprogressTripReassign = this.user.allowInprogressTripReassign;
          }

          if (this.user.hasOwnProperty("isShowCMS1500")) {
            this.isShowCms1500 = this.user.isShowCMS1500;
          }

          if (this.user.hasOwnProperty("outboundNumber")) {
            this.outBoundNumber = this.user.outboundNumber;
          }

          if (this.user.hasOwnProperty("autoFarmoutDispatch")) {
            this.isAutoFarmoutDispatch = this.user.autoFarmoutDispatch;
          }
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

    getTripPurpose() {
    this.tripPurposesService.getTripPurposesList("active")
     .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(data => {
      this.tripPurposesList = data;
    })
  }


  getTrips() {
    // this.filterdataList = [];
    // this.dataList = [];
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.todayDate,
      skip: this.skip,
    };
    this.assignTripService
      .getAssignList(object)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            data.forEach((trip) => {
              trip.isWillcall = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
            });
            this.dataList = [...data, ...this.dataList];
            this.filterdataList = this.dataList;
            this.group(true);


            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
              this.skip = 0;
              if (this.timer && this.status === 'unassigned') {
                if (this.isTimerEnabled)
                  this.timer.start();
              }
              this.drivers = [];
              this.stationManagerList = [];
              let cooperates = [];
              this.tripPurposesAndAddons = [];
              let levelOfServices = [];
              let spaceTypes = [];
              let serviceAreas = [];
              this.appointmentTypes = [];
              this.patients = [];
              this.dataList.forEach(trip => {

                if (trip.driver) {
                  this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName });
                }
                if (trip.driver && trip.driver.stationManager) {
                  this.stationManagerList.push(trip.driver.stationManager);
                }
                if (trip.cooperate) {
                  cooperates.push(trip.cooperate);
                }

                // if (trip.tripReason) {
                //   // remove the item having empty string
                //   const reasons = trip.tripReason.split(',').filter((reason) => reason !== '');
                //   if (reasons && reasons.length) {
                //     this.tripPurposesAndAddons.push(...reasons);
                //   }
                // }

                if (trip.addonServices && trip.addonServices.length) {
                  for (let addon of trip.addonServices) {
                    this.tripPurposesAndAddons.push(addon.title);
                  }
                }

                if (trip.los) {
                  levelOfServices.push(trip.los);
                }

                if (trip.spaceType) {
                  spaceTypes.push(trip.spaceType);
                }

                if (trip.tripReason) {
                  // remove the item having empty string
                  if (trip.tripReason && trip.tripReason.length) {
                    this.appointmentTypes.push(...trip.tripReason);
                  }
                }
                // const zipCode = this.extractZipCode(trip.jobOriginAddress)
                if (trip.serviceArea) {
                  serviceAreas.push(trip.serviceArea);
                }
                if (trip.priorityClient) {
                  this.patients.push({ displayName: trip.priorityClient.displayName });
                }
              });


              if (this.selectedLOS && this.selectedLOS.length)
                levelOfServices.push(this.selectedLOS)

              if (this.selectedSpaceType && this.selectedSpaceType.length)
                spaceTypes.push(this.selectedSpaceType)

              if (this.selectedServiceArea && this.selectedServiceArea.length)
                serviceAreas.push(this.selectedServiceArea)

              if (this.selectedAptType && this.selectedAptType.length)
                this.appointmentTypes.push(this.selectedAptType)

              if (this.selectedPatient && this.selectedPatient.length)
                this.patients.push(this.selectedPatient)



              this.drivers = _.uniq(this.drivers, '_id').sort();
              this.stationManagerList = _.uniq(this.stationManagerList).sort();
              cooperates = _.uniq(cooperates).sort();
              this.tripPurposesAndAddons = [...new Set(this.tripPurposesAndAddons)].sort();
              levelOfServices = _.uniq(levelOfServices).sort();
              spaceTypes = _.uniq(spaceTypes).sort();
              serviceAreas = _.uniq(serviceAreas).sort();
              this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
              this.patients = _.uniq(this.patients, 'displayName').sort();

              if (cooperates && cooperates.length) {
                this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
              }

              if (levelOfServices && levelOfServices.length) {
                this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
              }

              if (serviceAreas && serviceAreas.length) {
                this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
              }

              if (spaceTypes && spaceTypes.length) {
                this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
              }

              if (this.status === 'unassigned') {
                this.selectedDriver = [];
                this.selectedStationManager = [];
              }
            }
          } else if (this.timer && this.status === 'unassigned') {
            if (this.isTimerEnabled)
              this.timer.start();
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          const indexOfDataList = _.findIndex(this.dataList, {
              _id: data.assignId,
          });
          const indexOfFilterdataList = _.findIndex(this.filterdataList, {
              _id: data.assignId,
          });
          if (this.status === 'all') {
            if (indexOfDataList > -1) {
              this.dataList[indexOfDataList].status = 'offered';
              this.dataList[indexOfDataList].jobStatus = 'offered';
              delete this.dataList[indexOfDataList].job;
            }

            if (indexOfFilterdataList > -1) {
              this.filterdataList[indexOfFilterdataList].status = 'offered';
              this.filterdataList[indexOfFilterdataList].jobStatus = 'offered';
              delete this.filterdataList[indexOfDataList].job;
            }
          } else {
            if (indexOfDataList > -1) this.dataList.splice(indexOfDataList, 1);
            if (indexOfFilterdataList > -1) this.filterdataList.splice(indexOfFilterdataList, 1);
          }
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.UPDATE_ASSIGN_TRIP)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          this.dataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.isMultiLoad = data.assign.isMultiLoad;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isDialysis = data.assign.isDialysis;
              item.isDeadMiles = data.assign.isDeadMiles;
              item.isLastTrip = data.assign.isLastTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
          this.filterdataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.isMultiLoad = data.assign.isMultiLoad;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isDialysis = data.assign.isDialysis;
              item.isDeadMiles = data.assign.isDeadMiles;
              item.isLastTrip = data.assign.isLastTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {

        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }

          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  onDateChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getTrips();
  }

  onTimeChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].toISOString(),
    ];
    this.getTrips();
  }

  onResetTime() {
    this.reset();
    this.skip = 0;
    this.clearTrips();

    this.todayDate = [
      moment(this.todayDate[0]).startOf("day").toISOString(),
      moment(this.todayDate[1]).endOf("day").toISOString(),
    ];

    this.getTrips();
  }

  getTimeRestrictions() {
    return { min: moment(this.todayDate[0]).startOf("day").toISOString(), max: moment(this.todayDate[1]).endOf("day").toISOString() }
  }

  setTripFilter() {
    this.filterTripsByModel();
  }

  // filterByStandingOrders(): void {
  //   console.log('this.isStandingOrderChecked', this.isStandingOrderChecked);
  //   if (this.isStandingOrderChecked) {
  //     this.filterdataList = this.dataList.filter(trip => trip.so);
  //   } else {
  //     this.filterdataList = [...this.dataList];
  //   }
  // }

  filterByStandingOrders() {
    this.filterTripsByModel();
  }

  claimFile(file) {
    let selectedTripIds;

    if (!this.selectedTrips.length)
      selectedTripIds = this.dataList.map((trip) => trip._id);
    else
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)

    let payload = {
      status: this.status,
      _ids: selectedTripIds,
      scheduleTime: this.todayDate,
    };


    if (file === "generateExcelFile") {
      this.assignTripService
        .generateTripsReport(payload)
         .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    } else if (file === "generateItineraryFile") {
      this.assignTripService
        .generateTripsIntineraryReport(payload)
         .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    }
  }

  driverMonitoringReport() {
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    let filterTrips = selectedTrip.filter(trip => trip.driver && trip.job && ["completed", "finished", "cancelled"].includes(trip.status))
    if (filterTrips && filterTrips.length) {
      this.csvService.driverMonitoringReport(filterTrips, this.todayDate, this.timeZone)
    }
  }

  getSelectedTrips() {
    return this.dataList
      .filter((trip) => trip.isSelected);

  }

  group(isNotFromButton?) {
    if (this.filterdataList && this.filterdataList.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filterdataList.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filterdataList.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }


  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  setPartialEditModal(trip) {
    this.partialEditModalObj = trip;
  }

  setModalContent(trips, type, ind?) {
    if (trips)
      this.assignModalObj = trips;
    else
      this.assignModalObj = this.getSelectedTrips().map((trip) => trip._id);

    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    if (type === "companyNote") {
      this.componentType = type;
    } else if (type === "dsr") {
      this.specialRate = JSON.parse(JSON.stringify(this.assignModalObj));
      this.componentType = type;
    } else if (type === "Multiple Assign") {
      this.componentType = type;
      this.secondaryCompType = this.status;
    } else {
      if (this.status === "hanging") {
        this.componentType = "hanging";
      } else if (this.status === "cancelled") {
        this.componentType = "cancelled";
      } else if (this.status === "archived") {
        this.componentType = "archived";
      } else if (this.status === "all") {
        this.componentType = "all";
      } else {
        this.componentType = type;
      }
    }
  }

  markTripPaid(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip paid?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
        };
        params["bankStatus"] = "paid";
        this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
      }
    });
  }

  tripAssignedResponse(tripStatus: string): void {
    // if (tripStatus === 'Trip Assigned' || tripStatus === 'Trip Un Assigned' || tripStatus === 'All Trips Assigned') {
    //   // sweetAlert('Success', tripStatus, 'success', 'OK');
    // } else if (tripStatus !== null) {
    //   sweetAlert('Error', tripStatus, 'error', 'OK');
    // }
    this.selectedTrips = [];
    this.assignModalObj = null;
    // this.clearTrips();
    this.skip = 0;
    this.getTrips();
  }

  onCloseModal(evt) {
    // if (evt) {
    this.assignModalObj = null;
    // }
  }

  verifiedCancelled(trip, ind) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.tripIndex = ind;
        const data = {
          isVerifiedCancelled: !trip.isVerifiedCancelled,
        };
        // this.store.dispatch(new VerifiedCancelledTrip(data, trip._id));
        this.assignTripService
          .verifiedCancelTrip(data, trip._id)
           .pipe(takeUntil(takeUntilDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                let tempInd = -1;
                _.find(this.dataList, (item, i) => {
                  if (item._id === this.filterdataList[this.tripIndex]._id) {
                    tempInd = i;
                    return i;
                  }
                });
                this.filterdataList[this.tripIndex].isVerifiedCancelled =
                  !this.filterdataList[this.tripIndex].isVerifiedCancelled;
                // this.dataList[tempInd].isVerifiedCancelled = !this.dataList[tempInd].isVerifiedCancelled;
                tempInd = -1;
              }
              this.tripIndex = -1;
            },
            (err) => {
              this.tripIndex = -1;
            }
          );
      }
    });
  }

  // Select/Un-Select All & Select Single Trip
  onSelectTrip(trip) {
    const index = this.selectedTrips.indexOf(trip._id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip._id);
    }
  }

  selectAllTrips() {
    this.filterdataList.forEach((assign) => {
      if (assign.status === "cancelled" && assign.job && assign.job._id) {
        return;
      }
      if (assign.issues && assign.issues.length) {
        return;
      }

      if (assign.isJClone) {
        return;
      }

      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });
    // }

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filterdataList.length;
    return this.isAllTripsSelected;
  }

  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();
  }

  filterTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isDriverExist = true;
      let isManualTrip = true;
      let isMarketPlace = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isServiceAreaExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;
      let isStaffExist = true;
      let isSoExist = true;
      let isFarmoutExist = true;
      let isPlannerExist = true;
      let isNewRequest = true;

      if (this.selectedDriver && this.selectedDriver.length) {
        if (trip.driver && trip.driver._id) {
          isDriverExist = this.selectedDriver.includes(trip.driver._id);
        } else {
          isDriverExist = false;
        }
      }
      if (this.isManual) {
        isManualTrip = !trip.rawId
      }
      if (this.isMarketPlace) {
        isMarketPlace = trip.jobStatus === 'marketplaced'
      }

      if (this.selectedStationManager && this.selectedStationManager.length) {
        if (trip.driver && trip.driver.stationManager) {
          isStaffExist = this.selectedStationManager.includes(trip.driver.stationManager);
        } else {
          isStaffExist = false;
        }
      }

      if (this.selectedPatient && this.selectedPatient.length) {
        if (trip.priorityClient && trip.priorityClient.displayName) {
          isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
        } else {
          isPatientExist = false;
        }
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        if (trip.spaceType) {
          isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
        } else {
          isSpaceTypeExist = false;
        }
      }

      if (this.selectedAptType && this.selectedAptType.length) {
        if (trip.tripReason) {
          isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
        } else {
          isAptTypeExist = false;
        }
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        if (trip.cooperate) {
          isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
        } else {
          isCorporateExist = false;
        }
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        if (trip.los) {
          islosExist = this.selectedLOS.includes(trip.los);
        } else {
          islosExist = false;
        }
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        if (trip.serviceArea) {
          isServiceAreaExist = this.selectedServiceArea.includes(trip.serviceArea);
        } else {
          isServiceAreaExist = false;
        }
      }

      if (this.isStandingOrderChecked) {
        isSoExist = trip.so
      }

      if (this.isFarmoutChecked) {
        isFarmoutExist = trip.farmout
      }

      if (this.isPlannerChecked) {
        isPlannerExist = trip.assignThrough === 'planner'
      }

      if (this.isNewRequestChecked) {
        isNewRequest = trip.viewStatus && trip.viewStatus === 'created' || false;
      }

      if (isDriverExist && isMarketPlace && isManualTrip && isStaffExist && isPatientExist && isSpaceTypeExist && isAptTypeExist && isCorporateExist && islosExist && isServiceAreaExist && isSoExist && isPlannerExist && isFarmoutExist && isNewRequest) {
        return true;
      } else {
        return false;
      }
    });
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filterdataList.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });

    this.selectedTrips = this.selectedTrips.filter(x => !unselectedTrips.includes(x));
    this.isAllTripsSelected = false;
  }

  sendMemberText(singleTrip, isMvt) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send ${isMvt ? 'verification' : 'confirmation'} SMS to members?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationText([singleTrip._id], isMvt);
        } else {
          const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
          this.requestConfirmationText(selectedTrips, isMvt);
        }
      }
    });
  }

  sendMemberCall(singleTrip) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send confirmation Call to member?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationCall(singleTrip);
        }
      }
    });
  }

  sendBulkMemberCall() {
    sweetAlert(
      "Alert",
      `Are you sure you want to send bulk confirmation Call to member?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.requestBulkConfirmationCall();
      }
    });
  }

  requestBulkConfirmationCall() {

    const selectedTrip = this.getSelectedTrips();

    const filteredTrips = selectedTrip.filter(trip => !(trip.isConfirmedTrip || trip.isReadyForPickup || trip.isMarkedCancelledTrip || trip.isHumanConfirmed || trip.isVoiceMail || trip.badPhoneNumber) && this.isTodayOrFuture(trip.scheduleTime));

    if (!filteredTrips.length) {
      return;
    }

    const payload = {
      trips: filteredTrips.map(trip => ({
        _id: trip._id,
        memberName: trip.priorityClient.displayName,
        to: trip.priorityClient.contactNumber,
        pickup: trip.jobOriginAddress,
        dropoff: trip.jobDestinationAddress,
        pickupTime: moment(trip.scheduleTime)
          .tz(this.timeZone)
          .format("MMMM D, YYYY h:mm A"),
        currentDateTime: moment()
          .tz(this.timeZone)
          .format("YYYY-MM-DD HH:mm:ss"),
      from: this.outBoundNumber,
      spaceType: this.preSpaceTypes[trip.spaceType].title,
      appointmentTime: moment(trip.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A"),

      }))
    };
    this.assignTripService
      .sendBulkConfirmationCall(payload)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  requestConfirmationText(selectedTrips, isMvt) {
    let payload = { selectedTrips };
    if (isMvt) {
      payload['isMvt'] = true;
    }
    this.assignTripService
      .sendConfirmationText(payload)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Text send to members successfully!",
            "Alert"
          );
          // sweetAlert('Success', 'Confirmation text sent to member successfully', 'success', 'OK');
        }
      });
  }

  requestConfirmationCall(selectedTrips) {
    let payload = {
      "_id": selectedTrips._id,
      "memberName": selectedTrips.priorityClient.displayName,
      "to": selectedTrips.priorityClient.contactNumber,
      "pickup": selectedTrips.jobOriginAddress,
      "dropoff": selectedTrips.jobDestinationAddress,
      "pickupTime": moment(selectedTrips.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A"),
      "currentDateTime": moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss"),
      "from": this.outBoundNumber,
      "spaceType": this.preSpaceTypes[selectedTrips.spaceType].title,
      "appointmentTime": moment(selectedTrips.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A"),

    };

    this.assignTripService
      .sendConfirmationCall(payload)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  adjustTrips() {
    const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
    const payload = { selectedTrips };
    this.assignTripService
      .autoTripAdjustment(payload)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            // sweetAlert('Success', 'Trips adjusted successfully', 'success', 'OK');
          }
        },
        (err) => {
          // this.clearSelection();
        }
      );
  }

  getParseTripList() {
    this.sweepTripsList = [
      {
        _id: "1",
        total: "",
        scraps: [
          {
            _id: "",
            rawId: "",
            created: "",
            type: "",
            company: "",
            jobs: "",
          },
        ],
      },
    ];
    // this.store.dispatch(new GetSweepTripsList());
    this.assignTripService
      .getSweepTripsList()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.sweepTripsList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // **************** ACTIONS ON TRIP ****************
  // Add Biller Note
  addBillerNote(trip, ind) {
    // this.tripIndex = ind;
    this.billerNoteModalObj = trip;
  }

  onBillerNoteAdded(event) {
    if (event) {
      // sweetAlert('Success', 'Biller Note Added Successfully', 'success', 'OK');
      this.billerNoteModalObj = null;
    } else {
      this.billerNoteModalObj = null;
    }
    // this.assignTripService
    //   .addBillerNote(event)
    //   .subscribe(data => {
    //     if (data) {
    //       let tempInd = -1;
    //         _.find(this.dataList, (item, i) => {
    //           if (item._id === this.filterdataList[this.tripIndex]._id) {
    //             tempInd = i;
    //             return i;
    //           }
    //         });
    //         this.filterdataList[this.tripIndex] = this.assignModalObj;
    //         this.dataList[tempInd] = this.assignModalObj;
    //         this.tripIndex = -1;
    //         tempInd = -1;
    //         this.assignModalObj = null;
    //     }
    //   }, err => {
    //     this.tripIndex = -1;
    //     sweetAlert('Error', err, 'error', 'OK');
    //   });
  }

  // Add Additional Note
  addAdditionalNote(trip, idx) {
    this.additionalNoteModalObj = trip;
  }

  onAdditionalNoteAdded(evt) {
    if (evt) {
      // sweetAlert('Success', 'Additional Note Added Successfully', 'success', 'OK');
    }
    this.additionalNoteModalObj = null;
  }

  // Add Special Rates
  addSpecialRates(data) {
    this.assignTripService
      .addSpecialRate(data)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.dataList[i].customerSpecialRate = data.customerSpecialRate;
                this.dataList[i].specialRate = data.specialRate;
              }
            });
            this.filterdataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.filterdataList[i].customerSpecialRate =
                  data.customerSpecialRate;
                this.filterdataList[i].specialRate = data.specialRate;
              }
            });
            // sweetAlert('Success', 'Trip Special Rate Added Successfully', 'success', 'OK');
          }
          this.closeActionMenu(null);
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
          this.closeActionMenu(null);
        }
      );
  }

  // Calculate Fare
  calculateFare(assign) {
    this.assignTripService
      .calculateFare(assign._id)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            assign.estimatedSpecialRate = data.totalFare || "";
            sweetAlert(
              "Alert",
              `Are you sure you want to update BSR Fare: $${data.totalFare} of '${assign.priorityClient.displayName}' - ${assign.tripId}`,
              "warning",
              "Yes",
              "No"
            ).then((result: any) => {
              if (result.value) {
                const payload = {
                  ...data,
                  _id: assign._id
                };
                this.updateDriverFare(payload);
              }
            });


          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // Add Special Rate
  addSpecialRate() {
    this.addSpecialRates(this.specialRate);
    // $('#dsrModal .close').click();
  }

  // Update Job - Mark Ready, Mark VIP, Mark Confirm, Mark Voicemail
  confirmedTrip(assign, assignKey) {
    let params = {
      assignId: assign._id,
    };

    if (!assign[assignKey]) {
      const options = this.tripPurposesList.map((item: any) => ({
        label: item.title,
        value: item.title
      }));

      const defaultOptions = assign.tripReason = assign.tripReason.filter(x => x.trim() !== '');

      this.sweetAlertService
        .openSelectModal('Alert', `Did '${assign.priorityClient.displayName}' confirm the appointment type for this trip?`, options, defaultOptions)
        .then(result => {
          if (result.value) {

            params[assignKey] = true;
            if (result.value.length) {
              const unique = Array.from(new Set(assign.tripReason.concat(result.value)));

              assign['tripReason'] = unique;
              params['tripReason'] = assign['tripReason'];
              this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
            } else {
              this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
            }
          }
        });
    } else {
      params[assignKey] = false;
      this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
    }
  }


  updateJob(assign, assignKey) {
  let params = {
      assignId: assign._id,
    };
    params[assignKey] = !assign[assignKey];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
  }
  sendForAuth(assign) {
    this.cms1500Service.sendForAuthPDF(assign, this.user);
  }

  // Update Job - Mark Ready, Mark VIP, Mark Confirm, Mark Voicemail
  dropTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to drop this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
          changeReason: "Will Do Later",
          driverId: assign.driver._id,
          company: { _id: this.user._id, displayName: this.user.displayName },
        };
        this.socketService.emit(Events.DROP_TRIP, params);
      }
    });
  }

  // Clone Trip
  cloneTrip(id) {
    sweetAlert(
      "Alert",
      "Are you sure you want to clone this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .cloneTrip(id)
           .pipe(takeUntil(takeUntilDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                this.getTrips();
                // sweetAlert('Success', 'Trip Cloned Successfully', 'success', 'OK');
              }
            },
            (err) => {
              sweetAlert("Error", err, "error", "OK");
            }
          );
      }
    });

    // const isConfirmed = confirm('Are you sure you want to clone this trip');
    // if (isConfirmed) {
    //   this.assignTripService
    //     .cloneTrip(id)
    //     .subscribe(data => {
    //       if (data) {
    //         sweetAlert('Success', 'Trip Cloned Successfully', 'success', 'OK');
    //       }
    //     }, err => {
    //       sweetAlert('Error', err, 'error', 'OK');
    //     });
    // }
  }

  cloneTrip2(trip:any){
      this.cloneTripObj = trip
  }



  // Remove Trip
  cancelTrip(trip, isNoShow?) {
    this.cancelTripModalObj = trip;
    if (isNoShow) {
      this.isNoShow = isNoShow;
    }
  }

  onCancelTrip(evt) {
    if (evt && evt.isByPassed) {
      // Edit Cancel Reason In Cancelled Tab
      // No need to splice the trip
      this.cancelTripModalObj = null;
      return;
    }
    if (evt) {
      const index = this.filterdataList.findIndex(
        (trip) => trip._id === evt._id
      );
      this.filterdataList.splice(index, 1);

    }
    this.cancelTripModalObj = null;
    this.isNoShow = false;
  }

  editCancelReason(trip) {
    trip.isByPassed = true;
    this.cancelTripModalObj = trip;
  }

  updateDriverFare(payload) {
    this.dispatchCenterService
      .saveDriverFare(payload)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.filterdataList.forEach((trip) => {
            if (trip._id === payload._id) {
              trip.preSpecialRate = payload.totalFare || "";
            }
          });
          this.selectedTrip = null;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  rejectRide(assign, index) {
    sweetAlert(
      "Alert",
      "Are you sure you want to re-route this Trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.status = "archived";
        this.assignTripService
          .assignTrip(assign)
           .pipe(takeUntil(takeUntilDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              const filterIndex = this.filterdataList.findIndex(t => t._id === assign._id);
              const dataIndex = this.dataList.findIndex(t => t._id === assign._id);
             //splice both lists
                if (filterIndex > -1 && dataIndex > -1) {
                  this.filterdataList.splice(filterIndex, 1);
                  this.dataList.splice(dataIndex, 1);
                }
              sweetAlert('Success', 'Trip Re-routed Successfully', 'success', 'OK');
            }
          });
      }
    });
  }

  markCompletedTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to complete this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .markCompletedTrip(assign)
           .pipe(takeUntil(takeUntilDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              const filterIndex = this.filterdataList.findIndex(t => t._id === assign._id);
              const dataIndex = this.dataList.findIndex(t => t._id === assign._id);
              if (this.status === 'all') {
                // update trip
                if (filterIndex > -1 && dataIndex > -1) {
                  this.filterdataList[filterIndex].status = data.status
                  this.filterdataList[filterIndex].jobStatus = data.status
                  this.filterdataList[filterIndex].trackId = data.trackId
                  this.dataList[dataIndex].status = data.status;
                  this.dataList[dataIndex].jobStatus = data.status;
                  this.dataList[dataIndex].trackId = data.trackId;
                }
              } else {
                //splice both lists
                if (filterIndex > -1 && dataIndex > -1) {
                  this.filterdataList.splice(filterIndex, 1);
                  this.dataList.splice(dataIndex, 1);
                }
              }
            }
          });
      }
    });
  }

  cancelCompleted(assign, index) {
    assign.isFinishedCalled = true;
    assign.isByPassed = true;
    this.cancelTripModalObj = assign;
  }

  markDvRequired(assign, index) {
    this.assignTripService
      .updateTrip(assign)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `${assign.isDvRequired ? 'Marked' : 'Un-Marked'} DV Required Successfully`, 'success', 'OK');
        }
      });
  }

  isPaidTrip(assign, index) {
    this.assignTripService
      .updateTrip(assign)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `${assign.takeSignaturesOnly ? 'Marked' : 'Un-Marked'} Is Paid Successfully`, 'success', 'OK');
        }
      });
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  viewFarmoutDetails(trip) {
    this.openfarmoutModal(trip)
  }

  farmoutCancel(trip) {
    this.cancelRideRequest(trip.farmout)
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  editTrip(assign) {
    this.editTripModalObj = assign._id;
  }

  onEditTrip(event) {
    if (this.isStandingOrderClone && (event.status == 'standing' || event.jobStatus == 'standing')) {
      this.isStandingOrderClone = false;
      this.editTripModalObj = null;
      return;
    }
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      // const index = this.filterdataList.findIndex(event._id);
      if (
        moment(event.appointmentTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].appointmentTime).format(
          "YYYY-MM-DD"
        ) ||
        moment(event.scheduleTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")
      ) {
        // this.clearTrips();
        // this.getTrips();
        this.filterdataList.splice(idx, 1);
      } else {
        event.isWillcall = moment(event.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
        this.filterdataList[idx] = event;
      }
      this.editTripModalObj = null;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.settingInterval);
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  getStaffRoles() {
    if (this.user && this.user.roles) {
      if (typeof this.user.roles === "string") {
        if (this.user.sRoles)
          this.subMenus = this.menuService.getAssignedSubMenu(this.user.sRoles);
        else
          this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles);
      } else if (typeof this.user.roles === "object") {
        this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles[0]);
      }
    }

    if (this.subMenus && this.subMenus.length) {
      if (this.subMenus[0].value === "all" && this.subMenus.length > 1)
        this.status = this.subMenus[1].value;
      else this.status = this.subMenus[0].value;

      this.getTrips();
    }
  }

  onClearDriver() {
    this.selectedDriver = [];
  }
  onClearCooperate() {
    this.selectedCooperate = [];
  }

  onClearTripPurpose() {
    this.selectedTripPurpose = "";
  }

  onTimerComplete(): void {
    this.timer.init();
    // this.clearTrips();
    this.skip = 0;
    this.getTrips();
  }


  downloadDriverReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generateDriverReport(data);
  }

  corporateReport() {
    let trips;

    if (this.status === 'all' || !this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    const data = {
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generateCorporateReport(data);
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.skip = 0;
      this.getTrips();
    } else {
      this.timer.init();
    }
  }

  getCmsReport(trip) {
    let queryParams = {
      companyType: trip.companyType,
      tripIdentity: trip.tripIdentity,
      type: "triplogs",
    };
    if (trip.cooperate) {
      queryParams["cooperate"] = trip.cooperate._id;
    }
    this.cms1500Service.getCmsReport(queryParams, this.user);
  }


  markRead(assign) {
    if (assign.viewStatus === "returned") return;
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip as acknowledged?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.viewStatus = "";
        assign.dispatchNoteTwo += ` Mark Acknowledged : ${this.user.displayName
          } ${moment().tz(`${this.timeZone}`).format("MM/DD/YY HHmm")}`;
        this.assignTripService
          .assignTrip(assign)
           .pipe(takeUntil(takeUntilDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              // sweetAlert('Success', 'Ride Re-routed Successfully', 'success', 'OK');
              this.closeActionMenu(null);
            }
          });
      }
    });
  }

  // updatedJobFee(evt) {
  //   if (this.filterdataList && this.filterdataList.length) {
  //     const selectedTrip = this.filterdataList.find(
  //       (x) => x.job._id === evt.tripId
  //     );
  //     if (
  //       selectedTrip &&
  //       selectedTrip.job &&
  //       selectedTrip.job.driverFareDetail
  //     ) {
  //       selectedTrip.job.driverFareDetail.jobFee = evt.jobFee;
  //     }
  //   }
  // }

  updatedAssociateImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x._id === evt.tripId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updatedCompImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x.job._id === evt.jobId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updateTripData(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find((x) => x._id === evt._id);
      if (selectedTrip) {
        selectedTrip.attachment = evt.attachment;
        selectedTrip.companyNote = evt.companyNote;
        selectedTrip.dispatchNoteTwo = evt.dispatchNoteTwo;
        selectedTrip.jobDestinationAddress = evt.jobDestinationAddress,
        selectedTrip.jobDestinationLatitude = evt.jobDestinationLatitude,
        selectedTrip.jobDestinationLongitude = evt.jobDestinationLongitude,
        selectedTrip.zipCodeDest = evt.zipCodeDest
      }
    }
  }

  attachAssociateImg(trip) {
    this.associateImageModalObj = trip;
  }

  driverGrivenceReport(trip) {
    this.reportService.getDriverGrivenceReport(trip, this.user);
  }

  adjustCompletedTrips() {
    sweetAlert(
      "Alert",
      `Are you sure you want to adjust the trips?`,
      "warning",
      "Yes",
      "No"
    ).then((result) => {
      if (result.value) {
        const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
        const payload = {
          scheduleTime: this.todayDate.toString(),
          selectedTrips
        };
        this.assignTripService
          .adjustCompletedTrips(payload)
          .subscribe((data) => {
            if (data && data.success) {
              if (data.jobIds && data.jobIds.length) {
                this.filterdataList.forEach((trip) => {
                  if (
                    trip.job &&
                    trip.job._id &&
                    data.jobIds.includes(trip.job._id)
                  ) {
                    trip.job.isFareAdjusted = true;
                  }
                });
              }
              this.toastr.success(data.message, "Alert");
            }
          });
      }
    });
  }

  getETA(trip) {
    this.assignTripService
      .getETA(trip._id)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          trip.etaMessage = data.etaMessage;
        }
      });
  }

  openTripLog(assign) {
    this.tripLogObj = assign;
  }
  checkListModal(assign) {
    this.checkListObj = assign;
  }

  tripConfirmationReport() {
    let selectedTripIds;

    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds
    }
    this.assignTripService.downloadConfirmationReport(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + '/excel/' + name;
        downloadFile(url, '', name);
      }
    });
  }

  isOver48Hours(createdAt): boolean {
    const createdTime = moment(createdAt);
    const currentTime = moment();
    const differenceInHours = currentTime.diff(createdTime, 'hours');
    return differenceInHours > 48;
  }


  getAssisData() {
    this.assistService.getAllAssists()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assists = data;
          this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      });
  }

  archiveTrip(payload) {
    const params = {
      status: 'archived',
      isByPassed: true
    }
    this.assignTripService
      .archiveTrip(payload, params)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          sweetAlert('Success', 'Trip Updated', 'success', 'OK');
          this.getTrips();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  tripsReport() {
    let selectedTrips;

    if (!this.selectedTrips.length)
      selectedTrips = this.dataList;
    else
      selectedTrips = this.getSelectedTrips();
    const data = {
      selectedTrips,
      timezone: this.timeZone,
      scheduleTime: this.todayDate[0],
      endDate: this.todayDate[1],
      preCooperates:  this.preCooperates,
      preLevelOfServices: this.preLevelOfServices,
    };
    this.csvService.generateTripsReport(data);
  }

  prodCheck() {
    if (this.isProduction) {
      const companyId = this.user.company ? this.user.company._id : this.user._id
      if (companyId === '6463be83c60e5d659486581f') {
        return true;
      } else {
        return false;
      }

    }
    else {
      return true
    }
  }

  downloadR2Report() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      // corporate: this.selectedCooperate,
      // driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    // console.log("Trip Data",data);
    // return;
    this.csvService.generateCompletedTripReport(data);
  }

  downloadPassengerReport() {
    const trips = this.getSelectedTrips();
    const data = {
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generatePassengerReport(data);
  }


  downloadCompletedReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      // corporate: this.selectedCooperate,
      // driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    // console.log("Trip Data",data);
    // return;
    this.csvService.generateFinishedReport(data);
  }


  openfarmoutModal(farmoutTrip) {
    if (farmoutTrip.farmout && farmoutTrip.farmout.platform === 'lyft') {
      this.lyftDetailsModalObj = farmoutTrip;
    } else {
      this.farmoutDetails = farmoutTrip
      this.isfarmoutModal = true
    }
  }

  closelyftDetailsModal(evt) {
    this.lyftDetailsModalObj = null;
  }

  cancelRideRequest(farmoutTrip) {
    const companyId = this.user.company ? this.user.company._id : this.user._id
    sweetAlert('Alert', `Are you sure you want to cancel farmout trip?`, 'warning', 'Yes', 'No')
      .then((result) => {
        if (result.value) {
          this.farmoutService.cancelRideRequest(farmoutTrip.requestId, { company: companyId, platform: farmoutTrip.platform })
             .pipe(takeUntil(takeUntilDestroyed(this)))
            .subscribe((data) => {
              if (data) {
                  const index = this.filterdataList.findIndex(
                    (trip) => trip._id === data._id
                  );
                  this.filterdataList.splice(index, 1);
                sweetAlert("Success", 'Farmout trip cancel request in process.', "success", "OK");
              }
            }, (err) => {
              sweetAlert("Error", err, "error", "Ok");
            });
        }
      });
  }

  closefarmoutModal(evt) {
    this.isfarmoutModal = evt
  }

  isRdispatcher(assign) {
    let isAllowToView = true;
    if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
      if (assign.driver) {
        isAllowToView = assign.driver.stationManager === this.user.sId;
      }
    }
    return isAllowToView;
  }

  openTemplateSaveModal() {
    let driverMembers = {};
    this.filterdataList.forEach(trip => {
      if (trip.driver) {
        const driver = trip.driver;
        const member = trip.priorityClient;
        if (driverMembers[driver._id]) {
          const storedMemebers = driverMembers[driver._id].members;
          driverMembers[driver._id] = {
            driver: driver,
            members: [...storedMemebers, { _id: trip.client, ...member }]
          }
        } else {
          driverMembers[driver._id] = {
            driver: driver,
            members: [{ _id: trip.client, ...member }]
          }
        }
      }
    });

    const template = [];
    Object.keys(driverMembers).forEach(driverId => {
      let { driver, members } = driverMembers[driverId]
      members = _.uniq(members, '_id').sort();
      template.push({ driver, members });
    })
    this.templateSaveModalObj = template;
  }

  isNotCurrentDateTrip(trip) {
    return isNotCurrentDateTrip(trip, this.timeZone)
  }

  openRouteTracker(trip){
    this.routeTrackerObj = trip;
  }

  async createStandingOrder(assign) {
    const result = await sweetAlert('Alert', 'Do you want to create standing order?', 'warning', 'Yes', 'No');
    if (result.value) {
      this.editTripModalObj = assign._id;
      this.isStandingOrderClone = true;
    }
  }

  openWillCallModal(trip){
    this.willCallObj = trip;
  }

  closeWillCallModal(event){
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      this.filterdataList[idx] = event;
    }
    this.willCallObj = null;
  }

  clearFilter(filter) {
    this[filter] = [];
    this.filterTripsByModel();
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleetList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  onArrivedStatus(trip) {
    let actualPickup,pickupDuration;
    let status = "";

    const {trackInfoJob} = trip.job;
    if (trackInfoJob.jobArrived) {
      if (trackInfoJob.jobArrived.time) {
        actualPickup = moment(trackInfoJob.jobArrived.time).tz(this.timeZone).format("HH:mm a");
        pickupDuration = moment(trip.scheduleTime).diff(moment(trackInfoJob.jobArrived.time));
        pickupDuration = (pickupDuration / 60000).toFixed(0);

        const isEarly = moment(trip.scheduleTime).isAfter(moment(trackInfoJob.jobArrived.time));
        const diff = pickupDuration
        if (isEarly) {
          if (diff <= 15) {
            status = "On Time";
          } else {
            status = "Early";
          }
        } else {
          if (Math.abs(diff) <= 15) {
            status = "On Time";
          } else {
            status = "Late";
          }
        }
      }
    }
    return status;
  }

  onCompletedStatus(trip) {
    let actualDropOff, dropOffDuration;
    let status = "";

    const { trackInfoJob } = trip.job;
    if (trackInfoJob) {
      if (trackInfoJob.jobCompleted) {
        if (trackInfoJob.jobCompleted.time) {
          actualDropOff = moment(trackInfoJob.jobCompleted.time).tz(this.timeZone).format("HH:mm a");
          dropOffDuration = moment(trip.appointmentTime).diff(moment(trackInfoJob.jobCompleted.time))
          dropOffDuration = (dropOffDuration / 60000).toFixed(0)
          const isLate = moment(trip.appointmentTime).isAfter(moment(trackInfoJob.jobCompleted.time));
          const diff = dropOffDuration
          if (isLate) {
            if (diff <= 15) {
              status = "On Time";
            } else {
              status = "Early";
            }
          } else {
            if (Math.abs(diff) <= 15) {
              status = "On Time";
            } else {
              status = "Late";
            }
          }


        }
      }

    }
    return status;
  }

  sendBulkTripConfirmation() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send confirmation SMS to members?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          startDate: this.todayDate[0],
          endDate: this.todayDate[1]
        }
        this.assignTripService
          .sendBulkTripConfirmation(payload)
           .pipe(takeUntil(takeUntilDestroyed(this)))
          .subscribe(data => {
          }, err => {
            sweetAlert('Error', err, 'warning', 'OK');
          });
      }
    });
  }

  assingTripsConditions(assign) {
    let isAllowToView = false;
    if (
      assign.status !== 'finished' &&
      !assign.isJClone &&
      !assign.isSelected &&
      assign.issues.length === 0
    ) {
      if (assign.status === 'inprogress') {
        if (this.allowInprogressTripReassign && !assign.farmout) {
          isAllowToView = true;
        }
      } else if (['cancelled', 'archived'].includes(assign.status) && assign.job ) {
        isAllowToView = false;
      } else {
        isAllowToView = true;
      }
    }

    return isAllowToView;
  }

  async disableAutoFarmout(assign) {
    const result = await sweetAlert('Alert', 'Do you want to disable auto farmout for this trip?', 'warning', 'Yes', 'No');
    if (!result.value) return;
    this.assignTripService.updateTrip({ _id: assign._id, isAutoFarmoutDisabled: true })
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          assign.isAutoFarmoutDisabled = true;
          sweetAlert('Success', 'Auto Farmout Disabled for this trip', 'success', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  isValidFarmoutFare(assign) {
    if (!assign.preSpecialRate && !assign.farmout && !assign.farmout.totalFare) return false;
    const rate = assign.preSpecialRate;
    const fare = assign.farmout.totalFare;
    return fare < rate * 0.8;
  }

  openAiAssistantConversation(trip) {
    this.aiAssistantConversationObj = trip;
  }

  isTodayOrFuture(scheduleTime: string): boolean {
    const tripDate = moment.tz(scheduleTime, this.timeZone).startOf('day');
    const today = moment.tz(this.timeZone).startOf('day');

    return tripDate.isSameOrAfter(today);
  }

  sortTrips(column: string) {
    Object.keys(this.columnsSortOrder).forEach(col => {
      if (col !== column) {
        this.columnsSortOrder[col] = '';
      }
    })
    if (!this.columnsSortOrder[column]) {
      this.columnsSortOrder[column] = 'asc';
    } else {
      this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
    }

    this.filterdataList.sort((a: any, b: any) => {
      let valA = a[column] || 0;
      let valB = b[column] || 0;

      // handle date
      if (column === 'scheduleTime' || column === 'appointmentTime') {
        valA = moment(valA).valueOf();
        valB = moment(valB).valueOf();
      }

      // handle string numbers safely
      if (!isNaN(valA)) valA = Number(valA);
      if (!isNaN(valB)) valB = Number(valB);

      if (valA < valB) return this.columnsSortOrder[column] === 'asc' ? -1 : 1;
      if (valA > valB) return this.columnsSortOrder[column] === 'asc' ? 1 : -1;

      return 0;
    });

  }



}
